import companyModule, {
  MODULE_NAME as COMPANY_MODULE_NAME,
  GET_SELF
} from "@/core/services/store/company.module";
import SecureLS from "secure-ls";

const ls = new SecureLS({ encodingType: "aes", isCompression: true });

// Middleware -- route değişmeden önce gerekli kontrolleri yapıp route'a erişim kontrolü eklemek için yazıldı
const middlewares = {
  // Chat sayfası erişim kontrolü
  chatAccess: async (to, from, next) => {
    try {
      const store = require("@/core/services/store.js").default;

      if (!store.state[COMPANY_MODULE_NAME]) {
        store.registerModule(COMPANY_MODULE_NAME, companyModule);
      }

      // chat ayarları company apisinden alınıyor
      const response = await store.dispatch(COMPANY_MODULE_NAME + '/' + GET_SELF, {
        url: "api/company/self"
      });

      if (response && response.settings) {
        const chat_settings = response.settings.find(x => x.key === 'chat_is_disabled');
        const chat_is_disabled = chat_settings
            ? chat_settings.value === 1 || chat_settings.value === true || chat_settings.value === "1" || chat_settings.value === "true"
            : false;

        if (chat_is_disabled) {
          // redirect to dashboard
          next({ name: "user.index" });
          return;
        }
      }

      next();
    } catch (error) {
      console.error('Chat access middleware error:', error);
      // On error, allow access (default behavior)
      next();
    }
  },

  // Authentication - yetki kontrolü
  requireAuth: (to, from, next) => {
    const token = localStorage.getItem('token');
    if (token) {
      next();
    } else {
      next({ name: "login" });
    }
  },

  // Giriş yapmış kullanıcı auth sayfalarına erişemesin
  redirectIfAuthenticated: (to, from, next) => {
    const isAuthenticated = !!ls.get("token");
    if (isAuthenticated) {
      next({ path: "/dashboard" });
    } else {
      next();
    }
  },

};

// Middleware executor - middleware mantığında çalışan Fn
export const executeMiddleware = (middlewareList) => {
  return (to, from, next) => {
    let currentIndex = 0;

    const runNextMiddleware = () => {
      if (currentIndex >= middlewareList.length) {
        next(); // Tüm middleware'ler tamamlandı
        return;
      }

      const middleware = middlewareList[currentIndex];
      currentIndex++;

      if (typeof middleware === 'string' && middlewares[middleware]) {
        middlewares[middleware](to, from, (result) => {
          if (result === false) {
            next(false);
          } else if (result && typeof result === 'object') {
            next(result); // Yönlendirme
          } else {
            runNextMiddleware(); // Sonraki middleware'e geç
          }
        });
      } else if (typeof middleware === 'function') {
        middleware(to, from, (result) => {
          if (result === false) {
            next(false);
          } else if (result && typeof result === 'object') {
            next(result); // Yönlendirme
          } else {
            runNextMiddleware(); // Sonraki middleware'e geç
          }
        });
      } else {
        runNextMiddleware(); // Geçersiz middleware, sonrakine geç
      }
    };

    runNextMiddleware();
  };
};

export default middlewares;